import {TableSettings} from "../../../tableSettings";

export const allContainerStatusList:TableSettings = {
  tableVersion: 10024,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  flexResizer: false,

  alternateRows: true,
  columns: []
};